import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "4px 0 0",
	},
	icon: {
		marginRight: "4px",
		width: "16px",
		height: "16px",
	},
	text: {
		fontSize: "12px",
		lineHeight: "16px",
		fontFamily: "Inter-SemiBold",
		fontWeight: "600px",
		color: theme.palette.colors.purplishBlue,
	},
}));

const MasterNow = (props) => {
	const { text, svg } = props;
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.icon}>{svg}</div>
			<div className={classes.text}>{text}</div>
		</div>
	);
};

MasterNow.propTypes = {
	text: PropTypes.string,
};

export default MasterNow;
